export default __webpack_public_path__ + "static/media/bullet.4e127b92.svg";